import { render, staticRenderFns } from "./BatchSetingTask.vue?vue&type=template&id=0318d88e&scoped=true"
import script from "./BatchSetingTask.vue?vue&type=script&lang=js"
export * from "./BatchSetingTask.vue?vue&type=script&lang=js"
import style0 from "./BatchSetingTask.vue?vue&type=style&index=0&id=0318d88e&prod&lang=scss&scoped=true"
import style1 from "./BatchSetingTask.vue?vue&type=style&index=1&id=0318d88e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0318d88e",
  null
  
)

export default component.exports